import { useLocation } from "react-router-dom";
import { parse } from "query-string";

export function useQuery() {
  return parse(useLocation().search);
}
